import imagesLoaded from 'imagesloaded';

export default function init_gallery_modal() {
    'use strict';

    let elements,
        imageFormats = 'jpg, gif, png, bmp',
        lastElement = null,
        lastIndex = null,
        loadedLinks = [];

    function getLinkType(link) {
        let linkSplit = link.split('/'),
            lastSegment = linkSplit.length ? linkSplit[linkSplit.length - 1] : null;

        if (! lastSegment) {
            return 'iframe';
        }

        let ext = lastSegment.substring(lastSegment.lastIndexOf('.') + 1);

        if (imageFormats.indexOf(ext) !== -1) {
            return 'img';
        } else {
            return 'iframe';
        }
    }

    function onImageLoaded() {
        if (! lastElement || lastElement.tagName !== 'IMG') {
            return;
        }

        lastElement.width = lastElement.naturalWidth;
        lastElement.height = lastElement.naturalHeight;

        elements.galleryModal.classList.add('loaded');

        setTimeout(function () {
            elements.galleryModal.classList.add('fade-in');
        }, 10);
    }

    function closeModal() {
        elements.galleryModal.classList.add('fade-out');
        setTimeout(function () {
            elements.galleryModal.classList.remove('open');
            elements.galleryModal.classList.remove('visible');
            elements.galleryModal.classList.remove('loaded');
            elements.galleryModal.classList.remove('fade-in');
            elements.galleryModal.classList.remove('fade-out');
        }, 400);
    }

    function openLink(link) {
        if (loadedLinks.indexOf(link) === -1) {
            elements.galleryModal.classList.remove('loaded');
            loadedLinks.push(link);
        }

        if (lastElement) {
            elements.galleryModalInner.removeChild(lastElement);
        }

        elements.galleryModalInner.style.backgroundImage = '';

        let linkType = getLinkType(link);

        if (linkType === 'img' && ! ('objectFit' in document.documentElement.style)) {
            Object.assign(elements.galleryModalInner.style, {
                backgroundImage: `url(${link})`,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center'
            })

            elements.galleryModal.classList.add('visible');
            elements.galleryModal.classList.add('loaded');

            setTimeout(function () {
                elements.galleryModal.classList.add('fade-in');
                elements.galleryModal.classList.add('open');
            }, 15);
        } else {
            lastElement = document.createElement(linkType);

            lastElement.src = link;

            elements.galleryModalInner.appendChild(lastElement);

            if (linkType === 'img') {
                lastElement.classList.add('object-fit');
                lastElement.setAttribute('data-type', 'contain');
                elements.galleryModal.classList.add('visible');

                imagesLoaded(elements.galleryModalInner, onImageLoaded);

                setTimeout(function () {
                    elements.galleryModal.classList.add('open');
                }, 15);
            }
        }
    }

    function getGalleryLinkIndex(galleryLink) {
        let galleryLinks = elements.galleryLinks,
            galleryLinksLenth = galleryLinks.length,
            iter;

        for (iter = 0; iter < galleryLinksLenth; ++iter) {
            if (galleryLinks[iter] === galleryLink) {
                return iter;
            }
        }
    }

    function prev() {
        if (elements.galleryModal.classList.contains('open')) {
            --lastIndex;

            if (lastIndex < 0) {
                lastIndex = elements.galleryLinks.length - 1;
            }

            openLink(getGalleryLinkLink(elements.galleryLinks[lastIndex]));
        }
    }

    function next() {
        let galleryLinksLength;

        if (elements.galleryModal.classList.contains('open')) {
            ++lastIndex;

            galleryLinksLength = elements.galleryLinks.length;

            if (lastIndex > galleryLinksLength - 1) {
                lastIndex = 0;
            }

            openLink(getGalleryLinkLink(elements.galleryLinks[lastIndex]));
        }
    }

    function getGalleryLinkLink(galleryLink) {
        let link = galleryLink.getAttribute('href');

        if (! link) {
            link = galleryLink.getAttribute('data-href');
        }

        return link;
    }

    function onGalleryLinkClick(event) {
        event.preventDefault();

        let galleryLink = event.currentTarget,
            link = getGalleryLinkLink(galleryLink);

        lastIndex = getGalleryLinkIndex(galleryLink);

        if (link) {
            openLink(link);
        }
    }

    function onGalleryModalCloseClick() {
        closeModal();
    }

    function onKeyDown(event) {
        if (! elements.galleryModal.classList.contains('open')) {
            return;
        }

        if (event.keyCode === 37) {
            event.preventDefault();
            prev();

            return;
        }

        if (event.keyCode === 39) {
            event.preventDefault();
            next();

            return;
        }

        if (event.keyCode === 27) {
            event.preventDefault();

            closeModal();
        }
    }

    function cacheElements() {
        elements = {};

        elements.galleryLinks = document.querySelectorAll('.gallery-link');
        elements.galleryModal = document.getElementById('gallery-modal');
        elements.galleryModalInner = elements.galleryModal.querySelector('.gallery-modal-inner');
        elements.galleryModalClose = elements.galleryModal.querySelector('.gallery-modal-close');

        elements.galleryModalPrev = elements.galleryModal.querySelector('.gallery-modal-prev');
        elements.galleryModalNext = elements.galleryModal.querySelector('.gallery-modal-next');
    }

    function setFixedListeners() {
        Array.prototype.forEach.call(elements.galleryLinks, function (galleryLink) {
            galleryLink.addEventListener('click', onGalleryLinkClick);
        });

        elements.galleryModalClose.addEventListener('click', onGalleryModalCloseClick);

        document.addEventListener('keydown', onKeyDown);

        elements.galleryModalPrev.addEventListener('click', prev);
        elements.galleryModalNext.addEventListener('click', next);
    }

    cacheElements();
    setFixedListeners();

    return {
        openLink: openLink
    };
};